var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'result-tabs',
        {
            'scroll-left': _vm.scrollEdge.left,
            'scroll-right': _vm.scrollEdge.right
        }
    ]},[_c('ul',{staticClass:"tabs-list inline-list",on:{"scroll":_vm.onScroll}},_vm._l((_vm.tabs),function(tab){return _c('li',{key:_vm.$t(tab.label),staticClass:"tab-item",class:{ current: _vm.isCurrent(tab) },attrs:{"tabindex":"2"}},[_c('a',{attrs:{"href":tab.href},on:{"click":function($event){$event.preventDefault();return _vm.switchTab(tab)}}},[_vm._v(_vm._s(_vm.$t(tab.label)))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e86b4fda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultTabs/ResultTabs.vue
// module id = null
// module chunks = 